import { NotificationConfiguration } from '../notification.templates';

export const PUBLISH_MEETING_TEMPLATE: NotificationConfiguration = {
  inapp: `<b>{triggeredByName}</b> published meeting agenda.`,
  email: {
    ctaKey: 'go_to_meeting',
  },
};
